import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import api from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { toast } from "sonner";

export default function SellerApply() {
  const [shop, setShop] = useState("");
  const [loading, setLoading] = useState(false);
  const { refresh, user } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/seller/apply", { shop_name: shop });
      await refresh();
      toast.success("Application submitted");
      navigate("/seller");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-[900px] mx-auto px-6 lg:px-10 py-14">
      <div className="text-[11px] uppercase tracking-[0.2em] text-[#0033FF] font-bold mb-2">Sell on MATRIX</div>
      <h1 className="font-display font-black text-4xl sm:text-6xl tracking-tight">Open a shop.</h1>
      <p className="mt-6 max-w-xl text-neutral-700">
        Apply to become a seller. Once approved by our team, you can list products, manage inventory, and fulfil orders.
      </p>

      {user?.role === "seller" ? (
        <div className="mt-10 border border-neutral-200 p-6">
          <div className="font-display font-bold text-xl">Status: <span className="text-[#0033FF]">{user.seller_status}</span></div>
          <p className="text-sm text-neutral-600 mt-2">
            {user.seller_status === "approved"
              ? "You are approved. Head to your seller dashboard."
              : "Your application is under review."}
          </p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 max-w-md space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="shop">Shop name</Label>
            <Input
              id="shop"
              data-testid="shop-name-input"
              required
              value={shop}
              onChange={(e) => setShop(e.target.value)}
              className="rounded-none border-black h-11"
            />
          </div>
          <Button data-testid="submit-apply-btn" disabled={loading} className="rounded-none bg-[#0033FF] hover:bg-[#0022CC] h-11 font-semibold px-6">
            {loading ? "Submitting…" : "Submit application"}
          </Button>
        </form>
      )}
    </div>
  );
}
